import { Features } from 'generated/featureDefinitions'

import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import hasFeature from 'modules/core/lib/hasFeature'

export const useCustomCandidateSourceFeatureAvailability = () => {
  const { featureAvailability } = useFeatureAvailability(Features.ats_customized_features)

  return hasFeature('dev_packaging_paywalls')
    ? featureAvailability.available
    : hasFeature('ats_sources_customization')
}
